//TopNavBar

import React from 'react'
import './TopNavBar.css'

export interface TopNavBarProps {
    trialExpired?: boolean;
    children?: React.ReactNode;
}

const TopNavBar: React.FC<TopNavBarProps> = ({
    trialExpired,
    children
}): JSX.Element => {
    return (
        <section className='TopNavbar'>
            <div className={`TopNavbar__content ${trialExpired ? 'trialLogo' : 'logo'} flex-v-center`}>
                {children}
            </div>
        </section>
    )
}

export default TopNavBar;